<template>
    <b-row v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
           class="content-header">

        <!-- Content Left -->
        <b-col class="content-header-left mb-10" >
            <b-row class="breadcrumbs-top">
                <b-col cols="12">
                    <h2 class="content-header-title float-left pr-10 mb-0">
                        {{ pageTitle || $route.meta.pageTitle }}
                    </h2>
                    <div class="breadcrumb-wrapper d-sm-none d-lg-block">
                        <b-breadcrumb>
                            <b-breadcrumb-item to="/">
                                <feather-icon icon="HomeIcon"
                                              size="16"
                                              class="align-text-top" />
                            </b-breadcrumb-item>
                            <b-breadcrumb-item v-for="item in $route.meta.breadcrumb"
                                               :key="item.text"
                                               :active="item.active"
                                               :to="item.to">
                                {{ item.active ?  pageTitle || item.text : item.text }}
                            </b-breadcrumb-item>
                        </b-breadcrumb>
                    </div>
                </b-col>
            </b-row>
        </b-col>

        <!-- Content Right -->
        <b-col cols="12" class="content-header-right text-md-right mb-10" md="auto">
            <portal-target name="buttons"></portal-target>
        </b-col>
    </b-row>
</template>

<script>
    export default {
        components: {},
        computed: {
            pageTitle() {
                return this.$store.state.app.pageTitle
            }
        }
    }
</script>
